import { computed, Directive, effect, ElementRef, inject, input, Renderer2, signal } from '@angular/core';
import { ImagesFacade } from '@app/store/images';

@Directive({
    selector: '[appImage]',
    host: {
        class: 'image-lazy',
    },
    exportAs: 'appImage',
})
export class ImageDirective {
    private renderer = inject(Renderer2);
    private elementRef = inject(ElementRef);
    private imagesFacade = inject(ImagesFacade);

    readonly src = input.required<string | undefined>();
    readonly fallbackImg = input('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');

    readonly loaded = signal(false);
    readonly image = computed(() => {
        const src = this.src();
        if (!src) return null;

        return this.imagesFacade.image(src)();
    });

    constructor() {
        effect(() => {
            const src = this.src();
            if (!src) return;

            this.imagesFacade.getImage(src);
        });

        effect(() => {
            const image = this.image();

            if (!image) {
                this.renderer.setAttribute(this.elementRef.nativeElement, 'src', this.fallbackImg());
            } else {
                this.elementRef.nativeElement.onload = () => {
                    this.loaded.set(true);
                    this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', '0');

                    requestAnimationFrame(() => {
                        this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', '1');
                    });
                };
                this.renderer.setAttribute(this.elementRef.nativeElement, 'src', image);
            }
        });
    }
}
